export const cdocs = [
	{
		"tajuk": {
			"la": "Gaudete Et Exultate",
			"en": "Gaudete Et Exultate",
			"id": "Bersukacitalah & Bergembiralah"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/04/Seri-Dokumen-Gerejawi-No-106-Gaudete-et-Exultate-4.pdf"
	},
	{
		"tajuk": {
			"la": "Christus Vivit",
			"en": "Christus Vivit",
			"id": "Kristus Hidup"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/08/Seri-Dokumen-Gerejawi-No-109-CHRISTUS-VIVIT-3.pdf"
	},
	{
		"tajuk": {
			"la": "Redemptoris Mater",
			"en": "The Mother of the Redeemer",
			"id": "Ibunda Sang Penebus"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-1-IBUNDA-SANG-PENEBUS-1.pdf"
	},
	{
		"tajuk": {
			"la": "",
			"en": "",
			"id": "Instruksi Mengenai kebebasan dan Pembebasan Kristiani"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-2-INSTRUKSI-MENGENAI-KEBEBASAN-DAN-PEMBEBASAN-KRISTIANI-1.pdf"
	},
	{
		"tajuk": {
			"la": "",
			"en": "",
			"id": "Keprihatinan Akan Masalah Sosial"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-3-KEPRIHATINAN-AKAN-MASALAH-SOSIAL-1.pdf"
	},
	{
		"tajuk": {
			"la": "Mewartakan Injil",
			"en": "",
			"id": "Evangelii Nuntiandi"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-6-EVANGELII-NUNTIANDI-2.pdf"
	},
	{
		"tajuk": {
			"la": "Querida Amazonia",
			"en": "",
			"id": "Ringkasan Querida Amazonia"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/02/Ringkasan-QUERIDA-AMAZONIA.pdf"
	},
	{
		"tajuk": {
			"la": "",
			"en": "Document on Human Fraternity for World Peace and Living Together",
			"id": "Dokumen Abu Dhabi"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/12/Dokumen-Abu-Dhabi.pdf"
	},
	{
	"tajuk": {
		"id": "MEMBANGUN-PERDAMAIAN-MENGHORMATI-MINORITAS",
		"la": "",
		"en": ""
	},
	"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/01/Seri-Dokumen-Gerejawi-No-4-MEMBANGUN-PERDAMAIAN-MENGHORMATI-MINORITAS.pdf"
	},
	{
		"tajuk": {
			"id": "Sabda Allah",
			"la": "Dei Verbum",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/01/Seri-Dokumen-Gerejawi-No-8-DEI-VERBUM.pdf"
	},
	{
		"tajuk": {
			"id": "Sacrosanctum Concilium",
			"la": "Sacrosanctum Concilium",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/02/Seri-Dokumen-Gerejawi-No-9-SACROSANCTUM-CONCILIUM.pdf"
	},
	{
		"tajuk": {
			"id": "DIGNITATIS HUMANAE NOSTRA AETATE",
			"la": "DIGNITATIS HUMANAE NOSTRA AETATE",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/01/Seri-Dokumen-Gerejawi-DIGNITATIS-HUMANAE-NOSTRA-AETATE.pdf"
	},
	{
		"tajuk": {
			"id": "Perfectae Caritatis",
			"la": "Perfectae Caritatis",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/01/Seri-Dokumen-Gerejawi-No-11-PERFECTAE-CARITATIS.pdf"
	},
	{
		"tajuk": {
			"id": "Apostilicam Actuositatem",
			"la": "Apostilicam Actuositatem",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/01/Seri-Dokumen-Gerejawi-No-12-APOSTOLICAM-ACTUOSITATEM.pdf"
	},
	{
		"tajuk": {
			"id": "Keluarga",
			"la": "Familiaris Consortio",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-30-FAMILIARIS-CONSORTIO-1.pdf"
	},
	{
		"tajuk": {
			"id": "Martabat Kaum Wanita",
			"la": "Mulieris Dignitatem",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-32-MULIERIS-DIGNITATEM-1.pdf"
	},
	{
		"tajuk": {
			"id": "Direktorium Tentang Pelayanan dan Hidup Para Imam",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-48-DIREKTORIUM-TENTANG-PELAYANAN-DAN-HIDUP-PARA-IMAM.pdf"
	},
	{
		"tajuk": {
			"id": "Gereja di Asia",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-57-GEREJA-DI-ASIA-1.pdf"
	},
	{
		"tajuk": {
			"id": "Perayaan Paskah & Persiapannya",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/01/Seri-Dokumen-Gerejawi-No-71-PERAYAAN-PASKAH-DAN-PERSIAPANNYA.pdf"
	},
	{
		"tajuk": {
			"id": "Donum Vitae",
			"la": "Donum Vitae",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/10/Seri-Dokumen-Gerejawi-No-75-DONUM-VITAE.pdf"
	},
	{
		"tajuk": {
			"id": "Kerjasama Awam & Imam Dalam Pastoral",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-84-KERJA-SAMA-AWAM-DAN-IMAM-DALAM-PASTORAL-1.pdf"
	},
	{
		"tajuk": {
			"id": "Hubungan Antar-agama dan Kepercayaan",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-85-HUBUNGAN-ANTARAGAMA-DAN-KEPERCAYAAN-2.pdf"
	},
	{
		"tajuk": {
			"id": "Pluralisme",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-86-PLURALISME-1.pdf"
	},
	{
		"tajuk": {
			"id": "Hukuman Mati",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-87-HUKUMAN-MATI-1.pdf"
	},
	{
		"tajuk": {
			"id": "Harapan Yang Menyelamatkan",
			"la": "Spe Salvi",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/2017/08/29/seri-dokumen-gerejawi-no-88-spe-salvi-harapan-yang-menyelamatkan/"
	},
	{
		"tajuk": {
			"id": "Kasih Dalam Kebenaran",
			"la": "Caritas in Veritate",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-89-CARITAS-IN-VERITATE-1.pdf"
	},
	{
		"tajuk": {
			"id": "Perdagangan Manusia, Wisata Seks, Dan Kerja Paksa",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-90-PERDAGANGAN-MANUSIA-WISATA-SEKS-KERJA-PAKSA-2.pdf"
	},
	{
		"tajuk": {
			"id": "Pintu Kepada Iman",
			"la": "Porta Fidei",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-91-PORTA-FIDEI-2.pdf"
	},
	{
		"tajuk": {
			"id": "Lingkungan Hidup",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-92-LINGKUNGAN-HIDUP-2.pdf"
	},
	{
		"tajuk": {
			"id": "Terang Iman",
			"la": "Lumen Fidei",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-93-LUMEN-FIDEI-2.pdf"
	},
	{
		"tajuk": {
			"id": "Sukacita Injil",
			"la": "Evangelii Gaudium",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-94-EVANGELII-GAUDIUM-1.pdf"
	},
	{
		"tajuk": {
			"id": "Tahun Hidup Bakti",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-95-TAHUN-HIDUP-BAKTI-1.pdf"
	},
	{
		"tajuk": {
			"id": "Panggilan & Misi Keluarga Dalam Gereja & Dunia Dewasa Ini",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-96-PANGGILAN-DAN-PERUTUSAN-KELUARGA-1.pdf"
	},
	{
		"tajuk": {
			"id": "Mendidik di Masa Kini & Masa Depan",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-97-MENDIDIK-DI-MASA-KINI-DAN-MASA-DEPAN-1.pdf"
	},
	{
		"tajuk": {
			"id": "Terpujilah Engkau",
			"la": "Laudato Si",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-98-LAUDATO-SI-1.pdf"
	},
	{
		"tajuk": {
			"id": "Kaya Dalam Kerahiman & Wajah Kerahiman",
			"la": "Dives in Misericordiae; Misericordiae Vultus",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-99-DIVES-IN-MISERICORDIA-MISERICORDIAE-VULTUS-1.pdf"
	},
	{
		"tajuk": {
			"id": "Sukacita Kasih",
			"la": "Amoris Laetitia",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-100-AMORIS-LAETITIA-2.pdf"
	},
	{
		"tajuk": {
			"id": "Menyambut Kristus Dalam Diri Pengungsi & Orang yang Terpaksa Mengungsi",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-101-MENYAMBUT-KRISTUS-DALAM-DIRI-PENGUNGSI-3.pdf"
	},
	{
		"tajuk": {
			"id": "Belas Kasih & Penderitaan",
			"la": "Misericordia Et Misera",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2017/08/Seri-Dokumen-Gerejawi-No-102-MISERICORDIA-ET-MISERA-3.pdf"
	},
	{
		"tajuk": {
			"id": "Panggilan & Misi Keluarga",
			"la": "Relatio Finalis",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2018/03/Seri-Dokumen-Gerejawi-No-103-RELATIO-FINALIS-PANGGILAN-DAN-MISI-KELUARGA-3.pdf"
	},
	{
		"tajuk": {
			"id": "Anggur Baru Dalam Kantong Kulit Baru",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/04/Seri-Dokumen-Gerejawi-No-104-ANGGUR-BARU-DALAM-KANTONG-KULIT-BARU-4.pdf"
	},
	{
		"tajuk": {
			"id": "Identitas & Misi Bruder Religius Dalam Gereja",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/04/Seri-Dokumen-Gerejawi-No-105-IDENTITAS-DAN-MISI-BRUDER-RELIGIUS-DALAM-GEREJA-3.pdf"
	},
	{
		"tajuk": {
			"id": "Orang Muda Iman & Penegasan Panggilan",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/05/Seri-Dokumen-Gerejawi-No-107-ORANG-MUDA-IMAN-DAN-PENEGASAN-PANGGILAN-3.pdf"
	},
	{
		"tajuk": {
			"id": "Maximum Illud",
			"la": "Maximum Illud",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/07/Seri-Dokumen-Gerejawi-No-108-MAXIMUM-ILLUD-4.pdf"
	},
	{
		"tajuk": {
			"id": "Gereja & Internet; Etika Dalam Internet; Perkembangan Cepat",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/09/Seri-Dokumen-Gerejawi-No-111-GEREJA-DAN-INTERNET-ETIKA-DAN-INTERNET-PERKEMBANGAN-CEPAT.pdf"
	},
	{
		"tajuk": {
			"id": "Communio Et Progressio",
			"la": "Communio Et Progressio",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/11/Seri-Dokumen-Gerejawi-No-112-COMMUNIO-ET-PROGRESSIO.pdf"
	},
	{
		"tajuk": {
			"id": "Aperuit Illis",
			"la": "Aperuit Illis",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/01/Seri-Dokumen-Gerejawi-APERUIT-ILLIS.pdf"
	},
	{
		"tajuk": {
			"id": "Tanda Yang Menakjubkan",
			"la": "Admirabile Signum",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2019/12/ADMIRABILE-SIGNUM.pdf"
	},
	{
		"tajuk": {
			"id": "Pedoman Homili",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/02/Seri-Dokumen-Gerejawi-No-113-PEDOMAN-HOMILI.pdf"
	},
	{
		"tajuk": {
			"id": "Pesan Bapa Suci Paus Fransiskus untuk Prapaskah 2020",
			"la": "",
			"en": ""
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/02/Pesan-Bapa-Suci-Paus-Fransiskus-untuk-Prapaskah-2020.pdf"
	},
	{
		"tajuk": {
			"id": "Bertolak Segar Dalam Kristus",
			"la": "",
			"en": "Starting Afresh from Christ; A Renewed Commitment to Consecrated Life in the Third Millenium"
		},
		"linkUrl": "http://www.dokpenkwi.org/wp-content/uploads/2020/03/Seri-Dokumen-Gerejawi-No-68-BERTOLAK-SEGAR-DALAM-KRISTUS.pdf"
	},
	{
		"tajuk": {
			"id": "Pesan Bapa Suci Fransiskus Untuk Hari Orang Sakit Sedunia Ke-28 (2020)",
			"la": "",
			"en": ""
		},
		"linkUrl": "https://static.youcat.id/docs/hoss28.pdf"
	},
	{
		"tajuk": {
			"id": "Panggilan Roma untuk Etika Kecerdasan Buatan",
			"la": "",
			"en": "Rome Call For AI Ethics"
		},
		"linkUrl": "https://static.youcat.id/docs/aiethics.pdf"
	},
	{
		"tajuk": {
			"id": "A. Gereja-gereja Sesaudari | B. Dominus Iesus",
			"la": "A. Sister Churches | B. Dominus Iesus",
			"en": "Sister Churches | The Lord Jesus"
		},
		"linkUrl": "https://static.youcat.id/docs/gerejasesaudariyesustuhan.pdf"
	},
	{
		"tajuk": {
			"id": "Instruksi Mengenai Doa Penyembuhan",
			"la": "",
			"en": "Instruction on Prayer for Healing"
		},
		"linkUrl": "https://static.youcat.id/docs/instruksidoapenyembuhan.pdf"
	},
	{
		"tajuk": {
			"id": "Rosario Perawan Maria",
			"la": "Rosarium Virginis Mariae",
			"en": "Rosary of the Virgin Mary"
		},
		"linkUrl": "https://static.youcat.id/docs/rosariumvirginismariae.pdf"
	}
]


// WEBPACK FOOTER //
// ./src/data/cdocs.js